import { GET_PREVIOUS_ALERTS } from "./constant";

export const getPreviousAlertsInfo = (params) => ({
  type: GET_PREVIOUS_ALERTS,
  params,
});
